<template>
  <div id="pretest">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="currentStep">
          <v-stepper-header>
            <v-stepper-step
              :complete="currentPretestPage > 2"
              step="1"
            >
              Preliminary Info
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :complete="currentPretestPage > 9"
              step="2"
            >
              Requirements Gathering
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :complete="currentPretestPage > 13"
              step="3"
            >
              Vendor Selection
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :complete="currentPretestPage > 15"
              step="4"
            >
              Investment and Budget Planning
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :complete="currentPretestPage > 16"
              step="5"
            >
              Results
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
        <v-progress-linear
          :value="percentComplete"
          :color="(percentComplete < 100 ? 'amber' : 'success')"
          height="35"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <div id="questionContainer">
      <div class="questionAndAnswerContainer">
        <transition name="fade" mode="out-in">
          <div class="page" :key="'page-0'" v-if="currentPretestPage === 0">
            <div class="questionDiv">Let's start with a little about you...</div>
            <v-form ref="form0" v-model="subformValidity.form0.valid">
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field class="pretest-text-input" label="First Name" outlined rounded v-model="pretestResponses[0].answer" :readonly="pretestResponses[0].locked" :rules="validationRules.notEmpty"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field class="pretest-text-input" label="Last Name" outlined rounded v-model="pretestResponses[1].answer" :readonly="pretestResponses[1].locked" :rules="validationRules.notEmpty"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field type="email" class="pretest-text-input" label="Email" outlined rounded v-model="pretestResponses[2].answer" :readonly="pretestResponses[2].locked" :rules="validationRules.email"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field class="pretest-text-input" label="Company" outlined rounded v-model="pretestResponses[3].answer" :readonly="pretestResponses[3].locked" :rules="validationRules.notEmpty"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-1'" v-if="currentPretestPage === 1">
            <div class="questionDiv">What disease space(s) are you launching in?</div>
            <v-form ref="form1" v-model="subformValidity.form1.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Allergy',
                        value: 'Allergy'
                      },
                      {
                        text: 'Autoimmune/immunology',
                        value: 'Autoimmune/immunology'
                      },
                      {
                        text: 'Cardiovascular',
                        value: 'Cardiovascular'
                      },
                      {
                        text: 'Dermatology',
                        value: 'Dermatology'
                      },
                      {
                        text: 'Endocrine',
                        value: 'Endocrine'
                      },
                      {
                        text: 'ENT/Dental',
                        value: 'ENT/Dental'
                      },
                      {
                        text: 'Gastroenterology (Non Inflammatory Bowel Disease)',
                        value: 'Gastroenterology (Non Inflammatory Bowel Disease)'
                      },
                      {
                        text: 'Hematology',
                        value: 'Hematology'
                      },
                      {
                        text: 'Infectious Disease',
                        value: 'Infectious Disease'
                      },
                      {
                        text: 'Metabolic',
                        value: 'Metabolic'
                      },
                      {
                        text: 'Neurology',
                        value: 'Neurology'
                      },
                      {
                        text: 'Obstetrics/Gynecology',
                        value: 'Obstetrics/Gynecology'
                      },
                      {
                        text: 'Oncology',
                        value: 'Oncology'
                      },
                      {
                        text: 'Ophthalmology',
                        value: 'Ophthalmology'
                      },
                      {
                        text: 'Orthopedics',
                        value: 'Orthopedics'
                      },
                      {
                        text: 'Psychiatry',
                        value: 'Psychiatry'
                      },
                      {
                        text: 'Renal',
                        value: 'Renal'
                      },
                      {
                        text: 'Respiratory',
                        value: 'Respiratory'
                      },
                      {
                        text: 'Rheumatology (Non Autoimmune)',
                        value: 'Rheumatology (Non Autoimmune)'
                      },
                      {
                        text: 'Urology',
                        value: 'Urology'
                      },
                      {
                        text: 'Other',
                        value: 'Other'
                      }
                    ]"
                    label="Disease Space(s)"
                    outlined
                    rounded
                    multiple
                    chips
                    deletable-chips
                    v-model="pretestResponses[4].answer"
                    :readonly="pretestResponses[4].locked"
                    :rules="validationRules.notEmptyList"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row v-if="pretestResponses[4].answer && pretestResponses[4].answer.includes('Other')">
                <v-col cols="12" sm="12">
                  <v-text-field class="pretest-text-input" label="Other Space(s)" placeholder="Please describe the other spaces..." outlined rounded v-model="pretestResponses[5].answer" :readonly="pretestResponses[5].locked" :rules="validationRules.notEmpty"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-2'" v-if="currentPretestPage === 2">
            <div class="questionDiv">What range best describes your current launch timing?</div>
            <v-form ref="form2" v-model="subformValidity.form2.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: '>24 Months',
                        value: '>24 Months'
                      },
                      {
                        text: '12-24 Months',
                        value: '12-24 Months'
                      },
                      {
                        text: '12 Months',
                        value: '12 Months'
                      },
                      {
                        text: '6-12 Months',
                        value: '6-12 Months'
                      },
                      {
                        text: '3-6 Months',
                        value: '3-6 Months'
                      },
                      {
                        text: '1-3 Months',
                        value: '1-3 Months'
                      },
                      {
                        text: '1 Month',
                        value: '1 Month'
                      }
                    ]"
                    label="Current Launch Timing?"
                    outlined
                    rounded
                    v-model="pretestResponses[6].answer"
                    :readonly="pretestResponses[6].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-3'" v-if="currentPretestPage === 3">
            <div class="questionDiv"><div><span class="user-submitted-info">{{ pretestResponses[0].answer }}</span>, perfect, we're moving right along.  Let's start grading your readiness.</div></div>
          </div>
          <div class="page" :key="'page-4'" v-if="currentPretestPage === 4">
            <div class="questionDiv"><div>I have identified the dates of...<br/><em class="question-disclaimer">(Choose all that apply)</em></div></div>
            <v-form ref="form3" v-model="subformValidity.form3.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Disease state training',
                        value: 'Disease state training'
                      },
                      {
                        text: 'Launch meeting',
                        value: 'Launch meeting'
                      },
                      {
                        text: 'CVA launch',
                        value: 'CVA launch'
                      },
                      {
                        text: 'PI approval',
                        value: 'PI approval'
                      },
                      {
                        text: 'None of the above',
                        value: 'None of the above'
                      }
                    ]"
                    label="I Have Identified the Dates of..."
                    outlined
                    rounded
                    multiple
                    chips
                    deletable-chips
                    v-model="pretestResponses[7].answer"
                    :readonly="pretestResponses[7].locked"
                    :rules="validationRules.notEmptyListNoneAbove"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-5'" v-if="currentPretestPage === 5">
            <div class="questionDiv"><div>I feel confident in my knowledge of...<br/><em class="question-disclaimer">(Choose all that apply)</em></div></div>
            <v-form ref="form4" v-model="subformValidity.form4.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Disease state',
                        value: 'Disease state'
                      },
                      {
                        text: 'Drug’s profile',
                        value: 'Drug’s profile'
                      },
                      {
                        text: 'Clinical data',
                        value: 'Clinical data'
                      },
                      {
                        text: 'Company culture',
                        value: 'Company culture'
                      },
                      {
                        text: 'Learners’ backgrounds and experience',
                        value: 'Learners’ backgrounds and experience'
                      },
                      {
                        text: 'None of the above',
                        value: 'None of the above'
                      }
                    ]"
                    label="I'm confident in..."
                    outlined
                    rounded
                    multiple
                    chips
                    deletable-chips
                    v-model="pretestResponses[8].answer"
                    :readonly="pretestResponses[8].locked"
                    :rules="validationRules.notEmptyListNoneAbove"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-6'" v-if="currentPretestPage === 6">
            <div class="questionDiv"><div>I have or am actively gathering...<br/><em class="question-disclaimer">(Choose all that apply)</em></div></div>
            <v-form ref="form5" v-model="subformValidity.form5.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Market research review',
                        value: 'Market research review'
                      },
                      {
                        text: 'Provider research',
                        value: 'Provider research'
                      },
                      {
                        text: 'Patient research',
                        value: 'Patient research'
                      },
                      {
                        text: 'Competitive intelligence',
                        value: 'Competitive intelligence'
                      },
                      {
                        text: 'Disease state understanding',
                        value: 'Disease state understanding'
                      },
                      {
                        text: 'Tactical brand planning',
                        value: 'Tactical brand planning'
                      },
                      {
                        text: 'Market access considerations',
                        value: 'Market access considerations'
                      },
                      {
                        text: 'None of the above',
                        value: 'None of the above'
                      }
                    ]"
                    label="Gathered or Gathering..."
                    outlined
                    rounded
                    multiple
                    chips
                    deletable-chips
                    v-model="pretestResponses[9].answer"
                    :readonly="pretestResponses[9].locked"
                    :rules="validationRules.notEmptyListNoneAbove"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-7'" v-if="currentPretestPage === 7">
            <div class="questionDiv"><div>Which stakeholders have you identified and engaged with so far?<br/><em class="question-disclaimer">(Choose all that apply)</em></div></div>
            <v-form ref="form6" v-model="subformValidity.form6.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Medical',
                        value: 'Medical'
                      },
                      {
                        text: 'Commercial',
                        value: 'Commercial'
                      },
                      {
                        text: 'Legal',
                        value: 'Legal'
                      },
                      {
                        text: 'Marketing/Brand',
                        value: 'Marketing/Brand'
                      },
                      {
                        text: 'Procurement',
                        value: 'Procurement'
                      },
                      {
                        text: 'None of the above',
                        value: 'None of the above'
                      }
                    ]"
                    label="Stakeholders Identified & Engaged With"
                    outlined
                    rounded
                    multiple
                    chips
                    deletable-chips
                    v-model="pretestResponses[10].answer"
                    :readonly="pretestResponses[10].locked"
                    :rules="validationRules.notEmptyListNoneAbove"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-8'" v-if="currentPretestPage === 8">
            <div class="questionDiv">I have met with the MLR team to share my launch training plan and to understand the MLR process and specific submission requirements.</div>
            <v-form ref="form7" v-model="subformValidity.form7.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      }
                    ]"
                    label="Met with the MLR Team?"
                    outlined
                    rounded
                    v-model="pretestResponses[11].answer"
                    :readonly="pretestResponses[11].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-9'" v-if="currentPretestPage === 9">
            <div class="questionDiv"><div><span class="user-submitted-info">{{ pretestResponses[0].answer }}</span>, let's talk training vendor selection progress. Our <em>favorite</em> topic, BTW.</div></div>
          </div>
          <div class="page" :key="'page-10'" v-if="currentPretestPage === 10">
            <div class="questionDiv"><div>Have you used a training partner at <span class="user-submitted-info">{{ pretestResponses[3].answer }}</span> previously?<br/><em class="question-disclaimer">Current or past vendors may have materials or source files you can leverage.</em></div></div>
            <v-form ref="form8" v-model="subformValidity.form8.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      },
                      {
                        text: 'Not Sure',
                        value: 'Not Sure'
                      },
                      {
                        text: 'Other',
                        value: 'Other'
                      }
                    ]"
                    label="Used a Training Partner?"
                    outlined
                    rounded
                    v-model="pretestResponses[12].answer"
                    :readonly="pretestResponses[12].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row v-if="pretestResponses[12].answer === 'Other'">
                <v-col cols="12" sm="12">
                  <v-text-field class="pretest-text-input" label="Other" placeholder="Please explain" outlined rounded v-model="pretestResponses[13].answer" :readonly="pretestResponses[13].locked" :rules="validationRules.notEmpty"></v-text-field>
                </v-col>
              </v-row>
              <div class="questionDiv followupQuestionDiv" v-if="pretestResponses[12].answer === 'Yes'"><div>The vendor(s) we currently use or have used in the past has expertise in the therapeutic area(s) selected earlier (<span class="user-submitted-info">{{ prettyAnswerList(pretestResponses[4].answer) }}</span>)</div></div>
              <v-row v-if="pretestResponses[12].answer === 'Yes'">
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      }
                    ]"
                    label="Previous Vendor Expertise?"
                    outlined
                    rounded
                    v-model="pretestResponses[14].answer"
                    :readonly="pretestResponses[14].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-11'" v-if="currentPretestPage === 11">
            <div class="questionDiv">Have you checked with procurement about previous training vendors and/or existing master service agreements (MSAs)?</div>
            <v-form ref="form9" v-model="subformValidity.form9.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      }
                    ]"
                    label="Checked with Procurement?"
                    outlined
                    rounded
                    v-model="pretestResponses[15].answer"
                    :readonly="pretestResponses[15].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-12'" v-if="currentPretestPage === 12">
            <div class="questionDiv">Have you scheduled capabilities presentations with life science sales training vendors?</div>
            <v-form ref="form10" v-model="subformValidity.form10.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      }
                    ]"
                    label="Scheduled Capabilities Presentations?"
                    outlined
                    rounded
                    v-model="pretestResponses[16].answer"
                    :readonly="pretestResponses[16].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-13'" v-if="currentPretestPage === 13">
            <div class="questionDiv">Next, we will explore your launch investment and budget planning readiness.</div>
          </div>
          <div class="page" :key="'page-14'" v-if="currentPretestPage === 14">
            <div class="questionDiv">I know my training budget for each fiscal year affected by this launch.</div>
            <v-form ref="form11" v-model="subformValidity.form11.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      }
                    ]"
                    label="Know Your Training Budget?"
                    outlined
                    rounded
                    v-model="pretestResponses[17].answer"
                    :readonly="pretestResponses[17].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-15'" v-if="currentPretestPage === 15">
            <div class="questionDiv"><div>Do you have any training assets that can be leveraged or repurposed when building out your launch curriculum?<br/><em class="question-disclaimer">Think of existing modules, print pieces or media that could be used as foundational or add-on pieces.</em></div></div>
            <v-form ref="form12" v-model="subformValidity.form12.valid">
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="[
                      {
                        text: 'Please Select',
                        value: null,
                        disabled: true
                      },
                      {
                        text: 'Yes',
                        value: 'Yes'
                      },
                      {
                        text: 'No',
                        value: 'No'
                      }
                    ]"
                    label="Any Assets to Leverage?"
                    outlined
                    rounded
                    v-model="pretestResponses[18].answer"
                    :readonly="pretestResponses[18].locked"
                    :rules="validationRules.notEmpty"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div class="page" :key="'page-16'" v-if="currentPretestPage === 16">
            <div class="questionDiv">...and that's all! It's just one more click to find out how prepared you are for your launch and to receive some helpful hints!</div>
          </div>
          <div class="page" :key="'page-17'" v-if="currentPretestPage === 17">
            <div class="questionDiv">
              <div>
                Grading Your Launch...<br/>
                <v-progress-circular
                  :rotate="-90"
                  :size="150"
                  :width="15"
                  :value="loadingCirclePercentComplete"
                  :color="(loadingCirclePercentComplete < 100 ? 'amber' : 'success')"
                >
                </v-progress-circular>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fastfade" mode="out-in">
          <v-row class="justify-center" v-show="showFeedback">
            <v-col cols="12" sm="10">
              <div class="feedbackDiv" v-if="hasFeedback(currentPretestPage)" v-html="getFeedback(currentPretestPage)"  style="min-height:150px; height: 100%; max-height:300px; justify-content: center; align-items: center; display: flex;"></div>
            </v-col>
          </v-row>
        </transition>

        <transition name="fade" mode="out-in">
          <div id="formControlContainer" v-if="currentPretestPage < 17">
            <v-row class="justify-center">
              <v-col cols="5"  sm="5" lg="4">
                <v-btn color="secondary" block large @click="goBack" :disabled="!hasPreviousPages">
                   BACK
                </v-btn>
              </v-col>
              <v-col cols="5"  sm="5" lg="4">
                <v-btn color="primary" block large @click="continueSurvey" v-if="showFeedback || isIntermediaryScreen">
                   CONTINUE
                </v-btn>
                <v-btn color="primary" block large @click="submit" :disabled="!subformValidity[getFormFromPage(currentPretestPage)].valid" v-else-if="!isIntermediaryScreen">
                   SUBMIT
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { axiosFormSubmit } from '../helpers/hubspot.js'

export default {
  name: 'Pretest',
  props: {
    
  },
  watch: {
    currentPretestPage(val){
      const thePretest = this;
      if(val === 17){
        thePretest.loadingInterval = setInterval(() => {
          if(thePretest.loadingCirclePercentComplete === 100){
            thePretest.continueSurvey();
            clearInterval(thePretest.loadingInterval);
          }
          thePretest.loadingCirclePercentComplete += 5;
        }, 100)
      }
    },
    pretestResponses: {
      handler: function(val){
        const thePretest = this;
        let changed = val.filter((value, index) => {
          return Object.keys(value).some((prop) => {
            // NOTE: This will not trigger on the first form element to be edited
              // Shouldn't matter in a practical sense; we only care about fields and values that show up later in the form
            if(thePretest.previousResponses.length > 0){
              if(Array.isArray(value[prop])){
                if(Array.isArray(thePretest.previousResponses[index][prop])){
                  return !thePretest.getArrayEquality(value[prop], thePretest.previousResponses[index][prop])
                }else{
                  return true;
                }
              }
              return value[prop] !== thePretest.previousResponses[index][prop];
            }
            return false;
          })
        });
        thePretest.updatePreviousResponses();
        if(changed.length > 0){
          let allLocked = changed.every(item => item.locked === true);

          // Don't trigger if user clicks submit button
          if(!allLocked){
            // probably move this to separate dedicated function
              // check against question id
                // then check against answer
                  // if answer makes other questions visible
                    // clear validation
                  // otherwise clear affected, now hidden, inputs, and revalidate
            switch(changed[0].questionID){
              case 4: // 'Other' included in the selections
              case 12: // 'Yes' or 'Other' selected
                thePretest.resetRelatedAnswers(changed[0].questionID);
                break;
              default:
                break;
            }
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'sectionsToReview',
    ]),
    currentStep(){
      const thePretest = this;
      let currentStep = 1;
      if(thePretest.currentPretestPage < 3){
        currentStep = 1;
      }else if(thePretest.currentPretestPage < 10){
        currentStep = 2;
      }else if(thePretest.currentPretestPage < 14){
        currentStep = 3;
      }else if(thePretest.currentPretestPage < 16){
        currentStep = 4;
      }else{
        currentStep = 5;
      }

      return currentStep;
    },
    hasPreviousPages(){
      const thePretest = this;
      return (thePretest.currentPretestPage >= 1);
    },
    isIntermediaryScreen(){
      const thePretest = this;
      return !(thePretest.pretestResponses.filter(pretestResponse => pretestResponse.pageNumber === thePretest.currentPretestPage).length > 0)
    },
    percentComplete(){
      const thePretest = this;
      let completedQuestions = 0;
      thePretest.pretestResponses.forEach(pretestResponse => {
        if(pretestResponse.pageNumber < thePretest.currentPretestPage){
          completedQuestions++;
        }
      })
      return ((completedQuestions / thePretest.pretestResponses.length ) * 100);
    }
  },
  methods: {
    ...mapActions([
      'displayResults',
      'submitAnswer',
      'completePretest',
      'addSectionToReview',
    ]),
    // check equality for arrays w/primitive values
    getArrayEquality(arrA, arrB){
      let testA = [];
      let testB = [];
      arrA.forEach(item => {
        testA.push(item)
      });
      arrB.forEach(item => {
        testB.push(item)
      });
      return (testA.sort().toString() === testB.sort().toString())
    },
    updatePreviousResponses(){
      const thePretest = this;
      thePretest.previousResponses = window.structuredClone(thePretest.pretestResponses)
    },
    getFormFromPage(){
      const thePretest = this;
      let currentFormToValidate = null;
      for (const [key, value] of Object.entries(thePretest.subformValidity)){
        if(value.pageNumber === thePretest.currentPretestPage){
          currentFormToValidate = key;
        }
      }
      return currentFormToValidate;
    },
    resetRelatedAnswers(questionID){
      const thePretest = this;
      let resetMap = [
        {
          questionID: 4,
          relatedQuestions: [5],
        },
        {
          questionID: 12,
          relatedQuestions: [13,14],
        },
      ];
      let matchingQuestion = resetMap.find(resetItem => resetItem.questionID === questionID);
      if(matchingQuestion){
        if(questionID === 4){
          if(thePretest.pretestResponses[4].answer && !thePretest.pretestResponses[4].answer.includes('Other')){
            thePretest.pretestResponses[5].answer = null;
          }
        }else if(questionID === 12){
          thePretest.pretestResponses[13].answer = null;
          thePretest.pretestResponses[14].answer = null;
        }else{
          matchingQuestion.relatedQuestions.forEach(relatedQuestion => {
            thePretest.pretestResponses[relatedQuestion].answer = null;
          });
        }
      }
    },
    submit(){
      this.lockAnswers(this.currentPretestPage)

      if(this.hasFeedback(this.currentPretestPage)){
        this.showFeedback = true;
      }else{
        this.currentPretestPage++;
        this.unlockAnswers(this.currentPretestPage)
      }
    },
    goBack(){
      const thePretest = this;
      thePretest.showFeedback = false;
      window.setTimeout(() => {
        thePretest.currentPretestPage--;
        thePretest.unlockAnswers(thePretest.currentPretestPage);
      }, 250);
    },
    continueSurvey(){
      const thePretest = this;
      thePretest.showFeedback = false;

      window.setTimeout(() => {
        // 17 = total number of pages, excluding page 0
        if(thePretest.currentPretestPage < 17){
          thePretest.currentPretestPage++;
          thePretest.unlockAnswers(thePretest.currentPretestPage);
        }else{
          thePretest.submitAnswers();
          thePretest.displayResults();
        }
      }, 250)
    },
    lockAnswers(pretestPage){
      const thePretest = this;
      thePretest.pretestResponses.forEach(pretestResponse => {
        if(pretestResponse.pageNumber === pretestPage){
          pretestResponse.locked = true;
        }
      })
    },
    unlockAnswers(pretestPage){
      const thePretest = this;
      thePretest.pretestResponses.forEach(pretestResponse => {
        if(pretestResponse.pageNumber === pretestPage){
          pretestResponse.locked = false;
        }
      })
    },
    submitAnswers(){
      const thePretest = this;
      let answerScore = null;
      let scoreResults = null;

      let answersToPost = {
        fields: []
      };

      thePretest.pretestResponses.forEach(pretestResponse => {
        if(pretestResponse.answer !== null){
          scoreResults = thePretest.getAnswerScore(pretestResponse.questionID, pretestResponse.answer);
          if(scoreResults){
            answerScore = scoreResults.score;
          }else{
            answerScore = 0;
          }
          if(scoreResults && scoreResults !== undefined && scoreResults.sectionsToReview && scoreResults.sectionsToReview.length > 0){
            scoreResults.sectionsToReview.forEach(sectionToReview => {
              if(!thePretest.sectionsToReview.includes(sectionToReview)){
                thePretest.addSectionToReview(sectionToReview);
              }
            })
          }

          // BUILD OBJECT FOR HUBSPOT SUBMISSION DEPENDING ON TYPE OF QUESTION
            // NOTE: Does not handle timestamp-esque questions that were removed during some round of review
          if(Array.isArray(pretestResponse.answer)){
            pretestResponse.answer.forEach(responseAnswer => {
              answersToPost.fields.push({
                objectTypeId: "0-1",
                name: pretestResponse.formInputName,
                value: responseAnswer
              })
            })
          }else{
            answersToPost.fields.push({
              objectTypeId: "0-1",
              name: pretestResponse.formInputName,
              value: pretestResponse.answer
            })
          }

        }
        thePretest.submitAnswer({
          questionID: pretestResponse.questionID,
          answer: pretestResponse.answer,
          score: answerScore,
          formInputName: pretestResponse.formInputName
        });
      });
    

      // POST ANSWERS TO HUBSPOT
      axiosFormSubmit(answersToPost);
    },
    getAnswerScore(questionID, questionAnswer){
      const scoringMap = [
        {
          questionID: 6,
          scores: [
            {
              answer: '>24 Months',
              score: 0,
              sectionsToReview: []
            },
            {
              answer: '12-24 Month',
              score: 0,
              sectionsToReview: []
            },
            {
              answer: '12 Months',
              score: 0,
              sectionsToReview: []
            },
            {
              answer: '6-12 Month',
              score: 0,
              sectionsToReview: []
            },
            {
              answer: '3-6 Month',
              score: 0,
              sectionsToReview: ["0_0_0"]
            },
            {
              answer: '1-3 Month',
              score: 0,
              sectionsToReview: ["0_0_0"]
            },
            {
              answer: '1 Month',
              score: 0,
              sectionsToReview: ["0_0_0"]
            }
          ]
        },
        {
          questionID: 7,
          scores: [
            {
              answerLength: 4,
              score: 10,
              sectionsToReview: []
            },
            {
              answerLength: 3,
              score: 6,
              sectionsToReview: ["0_0_5"]
            },
            {
              answerLength: 2,
              score: 4,
              sectionsToReview: ["0_0_5"]
            },
            {
              answerLength: 1,
              score: 2,
              sectionsToReview: ["0_0_5"]
            },
            {
              answerLength: 0,
              score: 0,
              sectionsToReview: ["0_0_5"]
            }
          ]
        },
        {
          questionID: 8,
          scores: [
            {
              answerLength: 5,
              score: 10,
              sectionsToReview: []
            },
            {
              answerLength: 4,
              score: 8,
              sectionsToReview: []
            },
            {
              answerLength: 3,
              score: 6,
              sectionsToReview: ["0_0_4"]
            },
            {
              answerLength: 2,
              score: 4,
              sectionsToReview: ["0_0_4"]
            },
            {
              answerLength: 1,
              score: 2,
              sectionsToReview: ["0_0_4"]
            },
            {
              answerLength: 0,
              score: 0,
              sectionsToReview: ["0_0_4"]
            }
          ]
        },
        {
          questionID: 9,
          scores: [
            {
              answerLength: 7,
              score: 10,
              sectionsToReview: []
            },
            {
              answerLength: 6,
              score: 8,
              sectionsToReview: []
            },
            {
              answerLength: 5,
              score: 6,
              sectionsToReview: ["0_0_3"]
            },
            {
              answerLength: 4,
              score: 6,
              sectionsToReview: ["0_0_3"]
            },
            {
              answerLength: 3,
              score: 4,
              sectionsToReview: ["0_0_3"]
            },
            {
              answerLength: 2,
              score: 4,
              sectionsToReview: ["0_0_3"]
            },
            {
              answerLength: 1,
              score: 2,
              sectionsToReview: ["0_0_3"]
            },
            {
              answerLength: 0,
              score: 0,
              sectionsToReview: ["0_0_3"]
            }
          ]
        },
        {
          questionID: 10,
          scores: [
            {
              answerLength: 5,
              score: 10,
              sectionsToReview: []
            },
            {
              answerLength: 4,
              score: 8,
              sectionsToReview: []
            },
            {
              answerLength: 3,
              score: 6,
              sectionsToReview: ["0_0_2"]
            },
            {
              answerLength: 2,
              score: 4,
              sectionsToReview: ["0_0_2"]
            },
            {
              answerLength: 1,
              score: 2,
              sectionsToReview: ["0_0_2"]
            },
            {
              answerLength: 0,
              score: 0,
              sectionsToReview: ["0_0_2"]
            }
          ]
        },
        {
          questionID: 11,
          scores: [
            {
              answer: 'Yes',
              score: 10,
              sectionsToReview: ["2_0_3"]
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["0_0_9","2_0_0"]
            }
          ]
        },
        {
          questionID: 12,
          scores: [
            {
              answer: 'Yes',
              score: 0,
              sectionsToReview: []
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["4_0_0","0_0_6"]
            },
            {
              answer: 'Not Sure',
              score: 0,
              sectionsToReview: ["4_0_0","0_0_6"]
            },
            {
              answer: 'Other',
              score: 0,
              sectionsToReview: []
            }
          ]
        },
        {
          questionID: 14,
          scores: [
            {
              answer: 'Yes',
              score: 10,
              sectionsToReview: []
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["4_0_0","0_0_6"]
            }
          ]
        },
        {
          questionID: 15,
          scores: [
            {
              answer: 'Yes',
              score: 10,
              sectionsToReview: []
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["4_0_0","0_0_2","0_0_6"]
            }
          ]
        },
        {
          questionID: 16,
          scores: [
            {
              answer: 'Yes',
              score: 10,
              sectionsToReview: []
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["4_0_0"]
            }
          ]
        },
        {
          questionID: 17,
          scores: [
            {
              answer: 'Yes',
              score: 10,
              sectionsToReview: []
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["0_0_7"]
            }
          ]
        },
        {
          questionID: 18,
          scores: [
            {
              answer: 'Yes',
              score: 10,
              sectionsToReview: ["0_0_2"]
            },
            {
              answer: 'No',
              score: 0,
              sectionsToReview: ["4_0_3","0_0_2"]
            }
          ]
        }
      ];

      let resultingScoreObject = {
        score: 0,
        sectionsToReview: []
      };
      let matchingScoreItem = scoringMap.find(scoreItem => scoreItem.questionID === questionID);
      if(matchingScoreItem){
        if(Array.isArray(questionAnswer)){
          let adjustedLength = 0;
          if(questionAnswer.includes('None of the above')){
            adjustedLength = -1;
          }
          resultingScoreObject = matchingScoreItem.scores.find(scoreItem => scoreItem.answerLength === (questionAnswer.length + adjustedLength));
        }else{
          resultingScoreObject = matchingScoreItem.scores.find(scoreItem => scoreItem.answer === questionAnswer);
        }
      }

      return resultingScoreObject;
    },
    prettyAnswerList(answerList){
      let prettyAnswerList = '';
      if(answerList){
        if(answerList.length === 2){
          prettyAnswerList = answerList.join(' or ');
        }else{
          prettyAnswerList = answerList.join(', ');
        }
      }
      return prettyAnswerList;
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    formatDateUnix (date) {
      if (!date) return null
      return Math.floor(new Date(date).getTime())
    },
    parseDate (date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getFeedback(pretestPage){
      const thePretest = this;
      let returnedFeedback = '';
      let matchingFeedbacks = thePretest.feedbackMap.filter(feedbackItem => feedbackItem.pageNumber === pretestPage)
      // if feedback doesn't depend on a specific answer, just return it for the page
        // otherwise check the answer against the appropriate set of answers to find the appropriate feedback option
      // NOTE: works on assumption that we only retrieve feedback once (on a per-page basis)
      if(matchingFeedbacks.length){
        if(matchingFeedbacks[0].feedbackMatchType === 'any'){
          returnedFeedback = matchingFeedbacks[0].feedback;
        }else{
          let questionID = matchingFeedbacks[0].questionID;
          let matchingAnswer = thePretest.pretestResponses.find(response => response.questionID === questionID).answer;
          let adjustedLength = 0;
          if(matchingFeedbacks[0].feedbackMatchType === 'length' && matchingAnswer.length > 1 && matchingAnswer.includes('None of the above')){
            adjustedLength = -1;
          }
          switch(matchingFeedbacks[0].feedbackMatchType){
            case 'includes':
              returnedFeedback = matchingFeedbacks.find(question => question.questionID === questionID && question.requiredVals.includes(matchingAnswer));
              break;
            case 'length':
              returnedFeedback = matchingFeedbacks.find(question => question.questionID === questionID && question.requiredLength.includes((matchingAnswer.length + adjustedLength)));
              break;
            default:
              break;
          }
          if(returnedFeedback){
            returnedFeedback = returnedFeedback.feedback
          }
        }
      }

      return returnedFeedback;
    },
    hasFeedback(pretestPage){
      const thePretest = this;
      let hasFeedback = false;
      let matchingQuestions = thePretest.feedbackMap.filter(feedbackItem => feedbackItem.pageNumber === pretestPage)
      if(matchingQuestions.length){
        hasFeedback = true;
        matchingQuestions.forEach(question => {
          if(question.feedbackMatchType !== 'any'){
            let possibleResponse = thePretest.pretestResponses.find(response => response.questionID === question.questionID);
            if(possibleResponse){
              if(possibleResponse.answer === null || possibleResponse.answer === ''){
                hasFeedback = false
              }else if(question.feedbackMatchType === 'includes'){
                if(matchingQuestions.find(matchingQuestion => matchingQuestion.requiredVals.includes(possibleResponse.answer)) === undefined){
                  hasFeedback = false
                }
              }
            }
          }
        });
      }
      return hasFeedback;
    }
  },
  mounted(){

  },
  created(){

  },
  destroyed(){

  }, 
  data(){
    return {
      canSubmit: false,
      subformValidity: {
        form0: {
          valid: false,
          pageNumber: 0
        },
        form1: {
          valid: false,
          pageNumber: 1
        },
        form2: {
          valid: false,
          pageNumber: 2
        },
        form3: {
          valid: false,
          pageNumber: 4
        },
        form4: {
          valid: false,
          pageNumber: 5
        },
        form5: {
          valid: false,
          pageNumber: 6
        },
        form6: {
          valid: false,
          pageNumber: 7
        },
        form7: {
          valid: false,
          pageNumber: 8
        },
        form8: {
          valid: false,
          pageNumber: 10
        },
        form9: {
          valid: false,
          pageNumber: 11
        },
        form10: {
          valid: false,
          pageNumber: 12
        },
        form11: {
          valid: false,
          pageNumber: 14
        },
        form12: {
          valid: false,
          pageNumber: 15
        }
      },
      validationRules: {
        notEmpty: [
          v => !!v || 'This field is required.'
        ],
        notEmptyList: [
          v => (!!v && !!v.length) || 'Please select at least one option.'
        ],
        notEmptyListNoneAbove: [
          v => (!!v && !!v.length) || 'Please select at least one option.',
          v => !(!!v && (v.length > 1) && v.includes('None of the above')) || 'Please select either "None of the above" OR the other options.'
        ],
        email: [
          v => !!v || 'This field is required',
          v => /.+@.+\..+/.test(v) || 'Email must be valid'
        ]
      },
      showFeedback: false,
      feedbackMap: [ // Filtered based on page number, then question ID, then check to see if answer is found in requiredVals
        {
          pageNumber: 0,
          questionID: null,
          requiredVals: [],
          requiredLength: [],
          feedbackMatchType: 'any',
          feedback: 'Thanks! Now let’s get to grading your launch training readiness.'
        },
        {
          pageNumber: 2,
          questionID: 6,
          requiredVals: ['>24 Months','12-24 Months','12 Months'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'Great job planning ahead. The fact that you have already started thinking about your launch means that you have an ample amount of time to prepare.'
        },
        {
          pageNumber: 2,
          questionID: 6,
          requiredVals: ['6-12 Months','3-6 Months'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'Launch will be here before you know it! Let’s help you figure out what else is still left to do.'
        },
        {
          pageNumber: 2,
          questionID: 6,
          requiredVals: ['1-3 Months','1 Month'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'Your launch is coming up quickly! Complete this form to make sure you have all your boxes checked!'
        },
        {
          pageNumber: 7,
          questionID: 10,
          requiredVals: [],
          requiredLength: [5,6],
          feedbackMatchType: 'length',
          feedback: 'Great job, you have reached out to 100% of the crucial stakeholders!'
        },
        {
          pageNumber: 7,
          questionID: 10,
          requiredVals: [],
          requiredLength: [4],
          feedbackMatchType: 'length',
          feedback: 'Almost perfect, you have reached out to 80% of the crucial stakeholders!'
        },
        {
          pageNumber: 7,
          questionID: 10,
          requiredVals: [],
          requiredLength: [1,2,3],
          feedbackMatchType: 'length',
          feedback: 'Make sure to reach out to all of the crucial stakeholders as soon as possible.'
        },
        {
          pageNumber: 8,
          questionID: 11,
          requiredVals: ['Yes','No'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'Building a good relationship with your MLR team is essential; they can guide you through the compliance landscape and help prevent rejections of training materials or multiple rounds of reviews'
        },
        {
          pageNumber: 10,
          questionID: 14,
          requiredVals: ['No'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'When selecting vendors, it is a good idea to focus on their expertise in the pharmaceutical industry specifically their familiarity with drug launches and your specific therapeutic area.'
        },
        {
          pageNumber: 12,
          questionID: 16,
          requiredVals: ['No'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'It may be a good time to look at new training vendors or catch up with existing ones to refresh on the latest trends, technology, and launch experience.'
        },
        {
          pageNumber: 14,
          questionID: 17,
          requiredVals: ['No'],
          requiredLength: [],
          feedbackMatchType: 'includes',
          feedback: 'Understanding the financial scope of your training will help you manage resources effectively.'
        },
      ],
      currentPretestPage: 0,
      tomorrow: ((new Date(Date.now() + 86400000)).toISOString().substr(0,10)), // 86400000 = 1 day
      loadingCirclePercentComplete: 0,
      loadingInterval: {},
      previousResponses: [],
      pretestResponses: [
        {
            questionID: 0,
            pageNumber: 0,
            formInputName: "firstname",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 1,
            pageNumber: 0,
            formInputName: "lastname",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 2,
            pageNumber: 0,
            formInputName: "email",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 3,
            pageNumber: 0,
            formInputName: "company",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 4,
            pageNumber: 1,
            formInputName: "disease_space",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 5,
            pageNumber: 1,
            formInputName: "disease_space_if_other",
            locked: false,
            answer: null,
            required: false,
            requiredIfDisplayed: false
        },
        {
            questionID: 6,
            pageNumber: 2,
            formInputName: "current_launch_timing",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 7,
            pageNumber: 4,
            formInputName: "identified_important_dates",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 8,
            pageNumber: 5,
            formInputName: "knowledge_confidence",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 9,
            pageNumber: 6,
            formInputName: "gathered_gathering",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 10,
            pageNumber: 7,
            formInputName: "stakeholders_identified_engaged",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 11,
            pageNumber: 8,
            formInputName: "met_with_mlr_team",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 12,
            pageNumber: 10,
            formInputName: "previously_used_training_partner",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 13,
            pageNumber: 10,
            formInputName: "previously_used_training_partner_if_other",
            locked: false,
            answer: null,
            required: false,
            requiredIfDisplayed: false
        },
        {
            questionID: 14,
            pageNumber: 10,
            formInputName: "previous_vendor_expertise",
            locked: false,
            answer: null,
            required: false,
            requiredIfDisplayed: true
        },
        {
            questionID: 15,
            pageNumber: 11,
            formInputName: "confirmed_previous_training_msas",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 16,
            pageNumber: 12,
            formInputName: "scheduled_or_completed_training_capabilities",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 17,
            pageNumber: 14,
            formInputName: "known_training_budget",
            locked: false,
            answer: null,
            required: true
        },
        {
            questionID: 18,
            pageNumber: 15,
            formInputName: "training_assets_available",
            locked: false,
            answer: null,
            required: true
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pretest{
  /*background-image: url(../assets/img/Quiz_bg.jpg);*/
  background-image: url(../assets/img/blastOff2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  top: 50px;
  position: absolute;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
/*  height: calc(100% - 50px);*/
  height: calc(100vh - 50px);
  height: calc(100svh - 50px);
}

#questionContainer{
  width: 80%;
  max-width: 768px;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}

.questionDiv{
  min-height: 100px;
  position: relative;
  margin: 0 auto;
/*  margin-top: 75px;*/
  margin-top: 25px;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  /*color: #1b4f6a;*/
  color: #304b8d;
  line-height: 1.1em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feedbackDiv{
  min-height: 75px;
  position: relative;
  margin: 0 auto;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  font-style: italic;
  color: #304b8d;
/*  line-height: 1.1em;*/
}

.question-disclaimer{
  font-size: .8em;
  line-height: .8em;
}

.followupQuestionDiv{
  margin-top: 0px;
}


.v-stepper, .v-stepper__header{
  max-height: 55px;
}

.v-stepper__step{
  padding: 12px 24px;
}

.user-submitted-info{
  /*color: #00BFA5;*/
  /*color: #5c82d1;*/
  /*color: #82bc5c;*/
  color: #62B160;
  font-size: 28px;
}


/*.page{

}

.page >>> .v-form{

}*/


#formControlContainer{
  position: fixed;
  bottom: 5%;
  left: 0;
  right: 0;
  width: 100%;
}


@media screen and (max-width: 900px){

}

@media screen and (max-width: 697px){
  .page >>> .v-slider__tick-label{
    overflow: hidden;
    max-width: 1ch;
    white-space: nowrap;
  }
}

@media screen and (max-width: 667px){
  #pretest{
    overflow-x: hidden;
  }

  .questionDiv{
    font-size: 16px;
    margin-top: 0px;
    min-height: 75px;
  }

  .feedbackDiv{
    line-height: 1em;
    font-size: 18px;
    padding: 0px;
  }

  .user-submitted-info{
    font-size: 18px;
  }

  .questionAndAnswerContainer{
    width: 100%;
  }

  #questionContainer{
    height: 100%;
  }

  #formControlContainer{
    bottom: 25px;
  }
}

.page >>> .v-select__selections .v-chip{
  /*background-color: #304b8d;*/
  background-color: #5c82d1;
  color: #f6f6f6;
}

.page >>> .v-select__selections .v-chip .v-chip__content .v-chip__close::before{
  color: #f6f6f6;
}


</style>